import { StyleSheet } from 'aphrodite';
import { titles, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	item: {
		display: 'flex',
		alignItems: 'center',
		padding: '12px 16px',
		backgroundColor: white,
		border: '1px solid #e5e7eb',
		borderRadius: 8,
		transition: 'all 0.15s ease',
		':hover': {
			borderColor: '#d1d5db',
			boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
		},
	},
	itemDragging: {
		boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
		transform: 'rotate(1deg)',
		borderColor: '#6366f1',
	},
	itemDisabled: {
		opacity: 0.6,
		cursor: 'not-allowed',
		':hover': {
			borderColor: '#e5e7eb',
			boxShadow: 'none',
		},
	},
	dragHandle: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: 4,
		marginRight: 12,
		color: '#9ca3af',
		cursor: 'grab',
		borderRadius: 4,
		':hover': {
			color: '#6b7280',
			backgroundColor: '#f3f4f6',
		},
		':active': {
			cursor: 'grabbing',
		},
	},
	dragHandleDisabled: {
		cursor: 'not-allowed',
		':hover': {
			color: '#9ca3af',
			backgroundColor: 'transparent',
		},
	},
	colorDot: {
		width: 12,
		height: 12,
		borderRadius: '50%',
		marginRight: 12,
		flexShrink: 0,
	},
	content: {
		flex: 1,
		minWidth: 0,
	},
	name: {
		fontSize: 14,
		fontWeight: 500,
		color: titles,
		marginBottom: 2,
	},
	filterSummary: {
		fontSize: 12,
		color: '#6b7280',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	defaultBadge: {
		fontSize: 11,
		fontWeight: 500,
		color: '#6b7280',
		backgroundColor: '#f3f4f6',
		padding: '4px 8px',
		borderRadius: 4,
		marginLeft: 12,
	},
});
